import {openModal} from '../Actions'
import DeletePostModal from './';

export const openDeletePostModal = post => {
	return openModal(DeletePostModal, {post});
}
